const Card = ({ children, className = '', hover = true, ...props }) => {
  return (
    <div 
      className={`card ${!hover ? 'hover:shadow-card' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}

export default Card


